<template>
  <div class="upload_grid">
    <van-uploader class="uploader" result-type="file" accept="*" :after-read="uploaderAfterRead">
      <div class="upload_tile">
        <div class="content">
          <div class="plus">+</div>
          <div class="caption">上传图片或视频</div>
        </div>
      </div>
    </van-uploader>

    <div class="uploaded_tile" v-for="(each,i) in attachmentList" :key="i">
      <img class="upload_img" v-if="isImage(each)" :src="each.filePath" />
      <a v-else class="file_link" target="_blank" :href="each.filePath">{{each.fileName}}</a>
    </div>
  </div>
<!-- Keep logic unchanged; only UI/Styles updated -->
</template>

<script>
import AbstractQiniuUploader from '@/assets/mixins/AbstractQiniuUploader';

export default {
  mixins : [ AbstractQiniuUploader ],

  name: "MobileTicketUploadBig",

  data() {
    return {
      uploaderDomain: null,
      attachmentList: []
    };
  },

  mounted() {
    // console.log('#28 MobileTicketUpload mounted', this);

    document.addEventListener('paste', this.onDocumentPaste);
  },

  methods: {
    onDocumentPaste(e) {
      if ( !e || !e.clipboardData || !e.clipboardData.items ) {
        console.log('#34 onDocumentPaste, no items', e);
        return;
      }

      var _this = this;

      var items = e.clipboardData.items;
      for (var i = 0; i < items.length; i++) {
        var _file = items[i].getAsFile();
        // console.log('#43', i, items[i], _file);

        this.requestQiniuToken_2('png', _token => {
          _this.uploadToQiniu_2(_file, _token, _attachment => {
            _this.attachmentList.push( _attachment );
          });
        });
      }
    },

    uploadToQiniu(_field, _token) {
      var _this = this;
      _this.uploadToQiniu_2(_field.file, _token, _attachment => {
        _this.attachmentList.push( _attachment );
      });
    },

    getAttachmentList() {
      return this.attachmentList;
    },

    setAttachmentList(_list) {
      this.attachmentList = _list;
    },

    //获取文件后缀名
    getSuffix(fileName) {
      var lastPlace = fileName.lastIndexOf(".");
      var fileNameLength = fileName.length;
      return fileName.substring(lastPlace + 1, fileNameLength);
    },

    requestQiniuToken(_field, _then) {
      var _suffix = this.getSuffix(_field.file.name);
      this.requestQiniuToken_2(_suffix, _then);
    },

    uploaderAfterRead(_field) {
      this.requestQiniuToken(_field, _token => {
        this.uploadToQiniu(_field, _token);
      });
    }
  }
};
</script>

<style scoped>
/* Grid layout: 4 columns, wrap as needed */
.upload_grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 0 10px;
}

/* Square tile for the uploader */
.upload_tile {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f7f8fa;
  border: 1px dashed #c8c9cc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #969799;
}

.upload_tile .content { text-align: center; }
.plus { font-size: 28px; line-height: 1; }
.caption { margin-top: 4px; font-size: 12px; }

/* Uploaded item tiles */
.uploaded_tile {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.upload_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.file_link {
  position: absolute;
  left: 8px;
  right: 8px;
  top: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  color: #1989fa;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketUploadBig.vue